<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <form [formGroup]="taskForm" class="needs-validation" novalidate>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Numar task</label>
                <input class="form-control" type="text" formControlName="number">
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Denumire task</label>
                <input class="form-control" type="text" formControlName="name">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>POD/CLC</label>
                <input class="form-control" type="text" formControlName="code">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Client</label>
                <input class="form-control" type="text" formControlName="client">
              </div>
              <div class="col-xl-3 col-md-3">
                <label>CUI/CNP</label>
                <input class="form-control" type="text" formControlName="clientCode">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Furnizor actual</label>
                <input class="form-control" type="text" formControlName="oldSupplier">
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Furnizor nou</label>
                <input class="form-control" type="text" formControlName="newSupplier">
              </div>
            </div>
            <ng-container *ngIf="taskType === 'ContractNetworkChangedInfoCCS'">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Motiv</label>
                  <input class="form-control" type="text" formControlName="reason">
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Descriere motiv</label>
                  <input class="form-control" type="text" formControlName="reasonDesc">
                </div>
              </div>
            </ng-container>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Modul de contractare al serviciului de retea</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isSupplierNetworkContractType()" disabled>
                  Prin furnizor
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isDirectNetworkContractType()" disabled>
                  Direct
                </label>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Adresa loc de consum</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="county">
                  <option *ngFor="let county of counties" [value]="county.name">
                    {{ county.name }} </option>
                </select>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="city">
                  <option *ngFor="let city of cities" [value]="city.name">
                    {{ city.name }} </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetName" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetNumber" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="block" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="floor" />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="apartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="postalCode" />
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Data efectiva a schimbarii furnizorului</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="date" formControlName="supplierChangeDate" onkeydown="return false">
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-1 col-md-1">
                <label>Tip contract</label>
              </div>
              <div class="col-xl-2 col-md-2">
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isContractTypeDistribution()" disabled>
                  Distributie
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isContractTypeTransport()" disabled>
                  Transport
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isContractTypeAccess()" disabled>
                  Acces la conductele de alimentare din amonte
                </label>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar contract</label>
                <input class="form-control" type="text" formControlName="contractNumber">
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Data contract</label>
                <input class="form-control" type="date" formControlName="contractDate" onkeydown="return false">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-2 col-md-2">
                <label>Exista conventie?</label>
              </div>
              <div class="col-xl-1 col-md-1">
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isConventionPresent()" disabled>
                  DA
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isConventionAbsent()" disabled>
                  NU
                </label>
              </div>
              <ng-container *ngIf="isConventionPresent()">
                <div class="col-xl-3 col-md-3">
                  <label>Tip conventie</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" [checked]="isConventionTypeTriple()" [disabled]="true">
                    Tripartita
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" [checked]="isConventionTypeMultiple()" [disabled]="true">
                    Multipartita
                  </label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Numar conventie</label>
                  <input class="form-control" type="text" formControlName="conventionNumber">
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Data conventie</label>
                  <input class="form-control" type="date" formControlName="conventionDate" onkeydown="return false">
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="isConventionPresent()">
              <div class="form-group row">
                <div class="col-xl-2 col-md-2">
                  <label>Parti conventie</label>
                </div>
                <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                  <!--<div *ngFor="let part of conventionParts" class="row">
                    <span class="list-item">{{part}}</span>
                  </div>-->
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-auto col-md-auto">
                  <!--<label class="d-block">
                    <input class="checkbox_animated" type="checkbox" disabled [checked]="suppliers.length > 1">
                    Exista mai multi furnizori
                  </label>-->
                </div>
                <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                  <!--<div *ngFor="let supplier of suppliers" class="row">
                    <span class="list-item">{{supplier}}</span>
                  </div>-->
                </div>
              </div>
            </ng-container>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Modalitate transmitere factura</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isInvoiceSentThroughEmail()" [disabled]="true">
                  Email
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isInvoiceSentThroughMail()" [disabled]="true">
                  Posta
                </label>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Modalitate restituire sume</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isMoneyReturnedThroughBank()" [disabled]="true">
                  Cont bancar
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" [checked]="isMoneyReturnedThroughPost()" [disabled]="true">
                  Mandat postal la adresa de corespondenta
                </label>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>IBAN cont bancar</label>
                <input class="form-control" type="text" formControlName="ibanBankAccount">
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Index</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Index</label>
                <input class="form-control" type="text" formControlName="index">
                <div
                  *ngIf="taskForm.controls.index.errors?.['counterIndexValueFormat'] && (taskForm.dirty || taskForm.touched)"
                  class="text text-danger">
                  Valoarea indexului ar trebui sa fie de forma cadran:valoare | numar cadran:valoare
                </div>
                <div
                  *ngIf="taskForm.controls.index.errors?.['counterIndexValueBigInt'] && (taskForm.dirty || taskForm.touched)"
                  class="text text-danger">
                  Valoarea indexului ar trebui sa fie un numar de tip intreg
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Data citire index</label>
                <input class="form-control" type="date" formControlName="indexDate" onkeydown="return false">
              </div>
            </div>
            <br>
            <ng-container *ngIf="showSendToFui">
              <div class="form-group row">
                <div class="col-xl-2 col-md-2">
                  <label>Transmite contract catre FUI?<span>*</span></label>
                </div>
                <div class="col-xl-1 col-md-1">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="sendToFUI" (click)="setSendToFUI(true)"
                      [checked]="isSentToFUI()" [disabled]="!editable">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="sendToFUI" (click)="setSendToFUI(false)"
                      [checked]="isNotSentToFUI()" [disabled]="!editable">
                    NU
                  </label>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="editable">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4>Semnatura</h4>
                </div>
              </div>
              <div class="signature-clear">
                <i class="fa fa-times-circle fa-2x red" (click)="signaturePad.clear()"></i>
              </div>
              <div #signatureDiv class="form-group row">
                <signature-pad #signaturePad class="signature" [options]="signaturePadOptions"></signature-pad>
              </div>
              <div class="form-group row">
                <label style="word-wrap:break-word">
                  <input class="checkbox_animated" id="signatureCheckBox" type="checkbox"
                    formControlName="signatureCheckBox" />
                  {{signatureCheckBoxText}}
                </label>
              </div>
              <br>
            </ng-container>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Documente</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-8 col-md-8">
                <span class="font-weight-bold">Fisier</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Dimensiune</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Optiuni</span>
              </div>
            </div>
            <div class="form-group row" *ngFor="let file of fileList">
              <div class="col-xl-8 col-md-8">
                <span>{{file.fileName}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span *ngIf="file.fileByteSize">{{file.fileByteSize | fileSize}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <a *ngIf="file.fileUrl" class="link pointer"
                  (click)="documentService.downloadDocument(file)">Descarca</a>
              </div>
            </div>
            <div class="form-group row pt-3">
              <div class="col-xl-3 col-md-3">
                <h4>{{externalLinksLabel}}</h4>
              </div>
            </div>
            <div class="form-group row" *ngFor="let url of urlList">
              <div class="col-xl-auto col-md-auto">
                <a href="{{url.value}}" target="_blank">{{url.value}}</a>
              </div>
            </div>
            <br>
            <div class="form-group row mb-0 pull-right">
              <div class="col-xl-auto col-md-auto">
                <button [routerLink]="'..'" type="button" class="mr-1 btn btn-light button-margin">Renunta</button>
                <button *ngIf="editable" type="button" class="btn btn-primary button-margin" (click)="onSubmit()">
                  Salveaza
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>